import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=24df821a&scoped=true&"
import script from "./MainLayout.vue?vue&type=script&lang=js&"
export * from "./MainLayout.vue?vue&type=script&lang=js&"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=24df821a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24df821a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24df821a')) {
      api.createRecord('24df821a', component.options)
    } else {
      api.reload('24df821a', component.options)
    }
    module.hot.accept("./MainLayout.vue?vue&type=template&id=24df821a&scoped=true&", function () {
      api.rerender('24df821a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainLayout.vue"
export default component.exports